package com.milta.core.localization.translations.pl

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Zaloguj się",
    logout = "Wyloguj się",
    email = "Email",
    password = "Hasło",
    showPassword = "Pokaż",
    hidePassword = "Ukryj",
    roleSelectionTitle = "Utwórz konto",
    roleSelectionSubtitle = "Wybierz typ konta odpowiadający Twojemu profilowi",
    roleDriverTitle = "Jestem kierowcą - dostawcą",
    roleDriverDescription = "Prowadzę pojazd transportowy lub dostawczy i chcę zoptymalizować moje trasy",
    roleDriverTag1 = "Optymalizuj moje trasy",
    roleDriverTag2 = "Oferty Milta na mojej trasie",
    roleEnterpriseTitle = "Jestem firmą",
    roleEnterpriseDescription = "Mam numer VAT i zarządzam flotą pojazdów i zespołem kierowców",
    roleEnterpriseTag1 = "Zarządzanie flotą",
    roleEnterpriseTag2 = "Śledzenie zespołów",
    continueButton = "Kontynuuj",
    registerFormTitle = "Dokończ rejestrację",
    registerFormSubtitle = "Potwierdź swój numer telefonu, aby aktywować konto.",
    registerFormSubtitleEnterprise = "Podaj nazwę organizacji i numer telefonu, aby aktywować konto.",
    googleAccountConnected = "Konto Google połączone",
    appleAccountConnected = "Konto Apple połączone",
    firstName = "Imię",
    lastName = "Nazwisko",
    phoneNumber = "Numer telefonu",
    phoneNumberHelper = "Wpisz wybrany numer telefonu.",
    phoneNumberOtpInfo = "Kod weryfikacyjny zostanie wysłany SMS-em, aby potwierdzić ten numer.",
    registerButton = "Otrzymaj kod weryfikacyjny",
    passwordHint = "Co najmniej 8 znaków",
    registerSuccess = "Konto zostało pomyślnie utworzone",
    errorEmailConflict = "Ten adres email jest już używany",
    errorPhoneConflict = "Ten numer telefonu jest już zarejestrowany",
    errorGeneric = "Połączenie nieudane. Sprawdź sieć i spróbuj ponownie.",
    errorFirstNameRequired = "Proszę podać swoje imię",
    errorFirstNameTooLong = "Imię nie może przekraczać 100 znaków",
    errorLastNameRequired = "Proszę podać swoje nazwisko",
    errorLastNameTooLong = "Nazwisko nie może przekraczać 100 znaków",
    errorPhoneTooLong = "Numer telefonu nie może przekraczać 20 znaków",
    errorOAuthAccountExists = "To konto jest już połączone z innym kontem Milta. Spróbuj się zalogować.",
    errorOAuthTokenInvalid = "Twoja sesja wygasła. Zaloguj się ponownie.",
    loginTitle = "Zaloguj się",
    loginTabPassword = "Hasło",
    loginTabPhone = "Telefon",
    loginButton = "Zaloguj się",
    forgotPassword = "Zapomniałeś hasła?",
    sendCodeButton = "Wyślij kod",
    otpTitle = "Wprowadź kod",
    otpSubtitle = "Wysłaliśmy 6-cyfrowy kod na",
    otpVerifyButton = "Weryfikuj",
    otpResend = "Wyślij kod ponownie",
    otpResendPrefix = "Nie otrzymałeś kodu?",
    otpWrongNumber = "Zły numer?",
    otpModifyLink = "Zmień",
    forgotPasswordTitle = "Zapomniane hasło",
    forgotPasswordSubtitle = "Podaj swój email, aby otrzymać link do resetowania",
    forgotPasswordButton = "Wyślij link",
    forgotPasswordSuccess = "Sprawdź swoją skrzynkę",
    resetPasswordTitle = "Nowe hasło",
    resetPasswordSubtitle = "Wybierz nowe hasło dla swojego konta",
    resetPasswordNewLabel = "Nowe hasło",
    resetPasswordConfirmLabel = "Potwierdź hasło",
    resetPasswordButton = "Zresetuj hasło",
    resetPasswordSuccess = "Hasło zresetowane. Możesz się teraz zalogować.",
    errorPasswordTooShort = "Hasło musi mieć co najmniej 8 znaków",
    errorPasswordTooLong = "Hasło nie może przekraczać 128 znaków",
    errorPasswordMismatch = "Hasła nie są zgodne",
    errorTokenInvalid = "Ten link do resetowania jest nieprawidłowy lub wygasł. Poproś o nowy.",
    errorEmailInvalid = "Wprowadz prawidlowy adres e-mail",
    errorPhoneRequired = "Wprowadz numer telefonu",
    errorInvalidCredentials = "Zły email lub hasło. Użyj opcji 'Zapomniałeś hasła?' jeśli potrzeba.",
    errorInvalidOtp = "Zły kod. Sprawdź SMS lub poproś o nowy.",
    errorExpiredOtp = "Kod wygasł. Poproś o nowy.",
    errorTooManyAttempts = "Zbyt wiele błędnych prób. Spróbuj ponownie za kilka minut.",
    errorResendLimit = "Zbyt wiele żądań ponownego wysłania. Spróbuj za kilka minut.",
    otpResendIn = "Wyślij ponownie za %d s",
    otpAttemptsLeft = "Pozostało %d prób",
    loginGreeting = "Witaj ponownie!",
    loginSubtitle = "Zaloguj się na swoje konto Milta",
    loginSmsOption = "Otrzymaj kod SMS",
    noAccount = "Nie masz jeszcze konta?",
    signUp = "Zarejestruj się",
    organizationName = "Nazwa organizacji",
    organizationNameRequired = "Proszę podać nazwę organizacji",
    registerNextButton = "Dalej",
    passwordConfirm = "Potwierdź hasło",
    passwordRuleUpper = "Jedna wielka litera",
    passwordRuleDigit = "Jedna cyfra",
    passwordRuleSpecial = "Jeden znak specjalny",
    alreadyHaveAccount = "Masz już konto — Zaloguj się",
)
